import { CreateQueryActionData } from "../api";
import { SavedQueryAction } from "./okta";

const outputMappings: CreateQueryActionData["body"]["outputMappings"] = [
  {
    isRoot: false,
    liquidTemplate:
      '[{% for item in items %}"{{ item.id.uniqueQualifier }}"{% unless forloop.last %},{% endunless %}{% endfor %}]',
    outputType: "LIST",
    qualifiedName: "miruviz.metadata.eventid",
    relationship: "toEventID",
  },
  {
    isRoot: false,
    liquidTemplate:
      '[\n{% assign first = true %}\n{% for item in items %}\n  {% assign app_name = "" %}\n\n  {% for param in item.events[0].parameters %}\n    {% if param.name == "APPLICATION_NAME" %}\n      {% assign app_name = param.value %}\n    {% endif %}\n  {% endfor %}\n\n  {% unless first %},{% endunless %}\n  "{{ app_name }}"\n  {% assign first = false %}\n{% endfor %}\n]',
    outputType: "LIST",
    qualifiedName: "miruviz.metadata.applicationname",
    relationship: "toApplicationName",
  },
  {
    isRoot: false,
    liquidTemplate:
      '[\n  {% for item in items %}\n    "{{ item.events[0].name }}"{% unless forloop.last %},{% endunless %}\n  {% endfor %}\n]',
    outputType: "LIST",
    qualifiedName: "miruviz.metadata.eventtype",
    relationship: "toEventType",
  },
  {
    isRoot: false,
    liquidTemplate:
      '[{% for item in items %}"{{ item.actor.email }}"{% unless forloop.last %},{% endunless %}{% endfor %}]',
    outputType: "LIST",
    qualifiedName: "miruviz.infrastructure.emailaddress",
    relationship: "toEmailAddress",
  },
  {
    isRoot: false,
    liquidTemplate:
      '[{% for item in items %}"{{ item.ipAddress }}"{% unless forloop.last %},{% endunless %}{% endfor %}]',
    outputType: "LIST",
    qualifiedName: "miruviz.infrastructure.ipv4address",
    relationship: "toIPv4address",
  },
  {
    isRoot: false,
    liquidTemplate:
      '[{% for item in items %}"{{ item.id.time }}"{% unless forloop.last %},{% endunless %}{% endfor %}]',
    outputType: "LIST",
    qualifiedName: "miruviz.metadata.eventtime",
    relationship: "toEventTime",
  },
  {
    isRoot: false,
    liquidTemplate:
      '[{% for item in items %}"{{ item.networkInfo.regionCode }}"{% unless forloop.last %},{% endunless %}{% endfor %}]',
    outputType: "LIST",
    qualifiedName: "miruviz.infrastructure.countrycode",
    relationship: "toCountryCode",
  },
];

export const googleQueryActions: SavedQueryAction[] = [
  {
    apiParameters: [
      {
        description: "",
        name: "startTime",
        type: "QueryParameter",
        value:
          "{{ 'now' | date: '%s' | minus: 7776000 | date: '%Y-%m-%dT%H:%M:%SZ' }}",
      },
    ],
    description:
      "List all System Log events by searching Email address. The Google Log records system events that are related to your organization in order to provide an audit trail that can be used to understand platform activity and to diagnose problems.",
    method: "GET",
    name: "Google Log Events 90 days - Email Search",
    outputMappings,
    requestPayload: "",
    type: "enrichment",
    url: "/activity/users/<<miruviz.infrastructure.emailaddress>>/applications/login",
  },
  {
    apiParameters: [
      {
        description: "",
        name: "startTime",
        type: "QueryParameter",
        value:
          "{{ 'now' | date: '%s' | minus: 259200 | date: '%Y-%m-%dT%H:%M:%SZ' }}",
      },
    ],
    description:
      "List all System Log events by searching Email address. The Google Log records system events that are related to your organization in order to provide an audit trail that can be used to understand platform activity and to diagnose problems.",
    method: "GET",
    name: "Google Log Events 72hours - Email Search",
    outputMappings,
    requestPayload: "",
    type: "enrichment",
    url: "/activity/users/<<miruviz.infrastructure.emailaddress>>/applications/login",
  },
  {
    apiParameters: [
      {
        description: "",
        name: "startTime",
        type: "QueryParameter",
        value:
          "{{ 'now' | date: '%s' | minus: 259200 | date: '%Y-%m-%dT%H:%M:%SZ' }}",
      },
      {
        description: "",
        name: "actorIpAddress",
        type: "QueryParameter",
        value: "<<miruviz.infrastructure.ipv4address>>",
      },
    ],
    description:
      "List all System Log events by searching Google Actor ID. The Google System Log records system events that are related to your organization in order to provide an audit trail that can be used to understand platform activity and to diagnose problems.",
    method: "GET",
    name: "Google Log Events 72hours - Actor Search",
    outputMappings,
    requestPayload: "",
    type: "enrichment",
    url: "/activity/users/all/applications/login",
  },
  {
    apiParameters: [
      {
        description: "",
        name: "startTime",
        type: "QueryParameter",
        value: "<<runtime.date.since>>",
      },
    ],
    description:
      "List all System Log events by searching Google Actor ID. The Google System Log records system events that are related to your organization in order to provide an audit trail that can be used to understand platform activity and to diagnose problems.",
    method: "GET",
    name: "Google Log - admin",
    outputMappings,
    requestPayload: "",
    type: "poller",
    url: "/activity/users/all/applications/admin",
  },
];
